import React from 'react';
import { Img, Txt } from "Components/GenericView";
import IOSSwitch from "Components/IosSwitch";
import "./style.css"

export interface Props {
  isReadOnly: boolean | undefined;
  toggleValueForReadOnly: boolean | undefined;
  toggleValueForActiveForm: boolean;
  onClick: (toggleValue: boolean) => void;
}

const AutoAssignToggle = (props: Props) => {
  const { isReadOnly, toggleValueForReadOnly, toggleValueForActiveForm, onClick } = props;

  if (isReadOnly) {
    return (
      <div className="flex center mt-2 mb-2">
        <Img src="/preferred cp.png" className="aat-icon" />
        <Txt className="aat-text mr-4 mt-1">
          Does CO has preferred CP or wants to review CP before assignment?
        </Txt>
        <span className="mt-1 ml-1 co-main-color top-relative-1 fs-14">
          {toggleValueForReadOnly ? "YES" : "NO"}
        </span>
      </div>
    )
  }

  return (
    <div className="flex center mt-2 mb-2">
      <Img src="/preferred cp.png" className="aat-icon" />
      <Txt className="aat-text mt-1">
        Does CO has preferred CP or wants to review CP before assignment?
      </Txt>
      <div className='aat-toggle-contaner'>
        <span className="co-main-color top-relative-1 fs-14">
          {toggleValueForActiveForm ? "YES" : "NO"}
        </span>
        <span onClick={() => onClick(!toggleValueForActiveForm)}>
          <IOSSwitch
            //@ts-ignore
            checked={toggleValueForActiveForm}
            onChange={() => { }}
          />
        </span>
      </div>
    </div>
  )
}

export default AutoAssignToggle;